import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import { LONG_DASH } from '../../constants/shared/CellConstants';
import Checkbox from '../../components/checkbox/Checkbox';
import { StudentInfoCell } from '../../components/cell/shared/Cells';
import { LANGUAGE, PERIOD } from '../../constants/shared/CommonConstants';
import { generateReactKey } from '../../utils/shared/commonUtils';

const { ENGLISH, SPANISH } = LANGUAGE;

const HomeConnectRow = props => {
    const { studentRow, index, handleCheckboxChanged, period } = props;
    const { availableMeasures, isEnglishChecked, isSpanishChecked, studentInfo } = studentRow;
    const { firstName, lastName, id } = studentInfo;

    return (
        <div className="home-connect-row">
            <div className="student-name-container">
                <StudentInfoCell
                    classNames="student-name"
                    lastName={lastName}
                    firstName={firstName}
                />
            </div>

            <div className="student-measures-container">
                <div className="student-measures">
                    {period !== PERIOD.SUMMER &&
                        availableMeasures.map(measure => (
                            <span key={generateReactKey(measure.key)} className="available-measure">
                                {measure.title}
                            </span>
                        ))}
                </div>
                <div className="checkboxes-container">
                    {isEmpty(availableMeasures) || period === PERIOD.SUMMER ? (
                        <>
                            <span className="home-connect-dash">{LONG_DASH}</span>
                            <span className="home-connect-dash">{LONG_DASH}</span>
                        </>
                    ) : (
                        <>
                            <Checkbox
                                id={ENGLISH + index}
                                className="home-connect-checkbox"
                                isChecked={isEnglishChecked}
                                handleCheckboxChanged={isChecked =>
                                    handleCheckboxChanged(isChecked, ENGLISH, id)
                                }
                            />
                            <Checkbox
                                id={SPANISH + index}
                                className="home-connect-checkbox"
                                isChecked={isSpanishChecked}
                                handleCheckboxChanged={isChecked =>
                                    handleCheckboxChanged(isChecked, SPANISH, id)
                                }
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

HomeConnectRow.defaultProps = {
    studentRow: {},
    period: '',
};

HomeConnectRow.propTypes = {
    index: PropTypes.number.isRequired,
    studentRow: PropTypes.object,
    handleCheckboxChanged: PropTypes.func.isRequired,
    period: PropTypes.string,
};

export default HomeConnectRow;
